import React, { useState , useEffect} from "react";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ProductModalityTab from "./ProductModalityTab";
import ManufacturingSupplyTab from "./ManufacturingSupplyTab";
import PlantTypeTab from "./PlantTypeTab";
import UOMTab from "./UOMTab";
import ProductTypeTab from "./ProductTypeTab";
import BatchStatusTab from "./BatchStatusTab";
import FormatTypeTab from "./FormatTypeTab";
import UploadFetchSettingTab from "./UploadFetchSettingTab";
import POStatusTab from "./POStatusTab";
import ShipmentStatusTab from "./ShipmentStatusTab";
import DocumentTypeTab from "./DocumentTypeTab";
import DocumentCategoriesTab from "./DocumentCategoriesTab";
import ManufacturingFacilityTypeTab from "./ManufacturingFacilityTypeTab";
import ReasonCodeGroupTab from "./ReasonCodeGroupTab";
import DigitalizationCodesTab from "./DigitalizationCodesTab";
import axios from "axios";
import MaterialTypeTab from './MaterialTypeTab';
import ProcessFlowTab from './ProcessFlowTab';
import RecheckTimeWindowTab from './RecheckTimeWindowTab';
// Custom Tab implementation
const CustomTab = ({ label, isActive, onClick }) => {
  const classes = useStyles();

  return (
    <div
      className={`${classes.customTab} ${isActive ? classes.activeTab : ""}`}
      onClick={onClick}
    >
      {label}
      {isActive && <div className={classes.tabIndicator} />}
    </div>
  );
};

// Custom TabPanel component
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(0),
    paddingTop: "0.5rem", // Reduced padding to decrease padding-left and padding-top
    paddingLeft: "0.5rem", // Reduced padding to decrease padding-left and padding-top
  },
  headerContainer: {
    marginBottom: theme.spacing(2),
  },
  headerText: {
    fontSize: "1.5rem",
    fontWeight: 600,
  },
  headerLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "4px 0 0 0",
  },
  tabsContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    marginBottom: "10px",
  },
  customTab: {
    textTransform: "none",
    fontSize: "1rem",
    cursor: "pointer",
    color: "#555",
    position: "relative",
    padding: "8px 0",
    "&:hover": {
      color: "#1890FF",
    },
  },
  activeTab: {
    fontWeight: 600,
    // color: "#1976d2",
    color: "#1890FF",
  },
  tabIndicator: {
    position: "absolute",
    bottom: -2,
    left: 0,
    right: 0,
    height: "3px",
    // backgroundColor: "#1976d2",
    backgroundColor: "#1890FF",
    borderRadius: "2px",
  },
  tabContent: {
    marginTop: theme.spacing(2),
  },
}));

// Mock components for each tab
const ProductModalityComponent = (props) => (
  <div>
    <ProductModalityTab handleNext={props.handleNext} />
  </div>
);

const ManufacturingSupplyTypeComponent = (props) => (
  <div>
    <ManufacturingSupplyTab
      handleNext={props.handleNext}
      handleBack={props.handleBack}
    />
  </div>
);
const PlantTypeComponent = () => (
  <div>
    <PlantTypeTab />
  </div>
);
const UOMComponent = () => (
  <div>
    <UOMTab />
  </div>
);
const ReasonCodeGroupComponent = () => (
  <div>
    <ReasonCodeGroupTab />
  </div>
);
const ProductTypeComponent = () => (
  <div>
    <ProductTypeTab />
  </div>
);
const ManufacturingFacilityTypeComponent = () => (
  <div>
    <ManufacturingFacilityTypeTab />
  </div>
);
const POStatusComponent = () => (
  <div>
    <POStatusTab />
  </div>
);
const BatchStatusComponent = () => (
  <div>
    <BatchStatusTab />
  </div>
);
const ShipmentStatusComponent = () => (
  <div>
    <ShipmentStatusTab />
  </div>
);
const DocumentTypeComponent = () => (
  <div>
    <DocumentTypeTab />
  </div>
);
const FormatTypeComponent = () => (
  <div>
    <FormatTypeTab />
  </div>
);
const DigitalizationCodesComponent = (props) => (
  <div>
    <DigitalizationCodesTab/>
  </div>
);
const FetchUploadSettingComponent = () => (
  <div>
    <UploadFetchSettingTab />
  </div>
);
const MaterialTypeComponent = () => (
  <div>
    <MaterialTypeTab />
  </div>
);
const ProcessFlowComponent = () => (
  <div>
    <ProcessFlowTab />
  </div>
);

const SponsorNetworkConfigurations = (props) => {
  const {
  openedTab,
  handleOpenTab,
  sponsorHandleNext,
  sponsorHandleBack,
  rowData,
  addSponsorList,
  updateNetworkData,
  rowNetwork
} = props
  const classes = useStyles();
  const [value, setValue] = useState(openedTab !== undefined ? openedTab : 0);
  const [plantTypes, setPlantTypes] = useState([]);
  const [uoms, setUoms] = useState([]);
  const [reasonCodeGroups, setReasonCodeGroups] = useState([]);
  const [loading, setLoading] = useState(false);
   const [error, setError] = useState(null);
     const [poStatuses, setPoStatuses] = useState([]);
     const [facilityTypes, setFacilityTypes] = useState([]);
     const [productTypes, setProductTypes] = useState([]);
   const [modalities, setModalities] = useState([]);
    const [formatTypes, setFormatTypes] = useState([]);
    const [digitalizationCodes, setDigitalizationCodes] = useState([]);
     const [documentTypes, setDocumentTypes] = useState([]);
     const [documentCategories, setDocumentCategories] = useState([]);
      const [shipmentStatuses, setShipmentStatuses] = useState([]);
        const [batchStatuses, setBatchStatuses] = useState([]);
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
    const [lastSyncTime, setLastSyncTime] = useState(new Date());
    const [uploadSuccess, setUploadSuccess] = useState(false);
     const [reasonCodes, setReasonCodes] = useState([]);
     const [productModalities, setProductModalities] = useState(false);
     const [manufacturingSupplyTypes, setManufacturingSupplyTypes] = useState(false);
  const [plantType, setPlantType] = useState(false);
  const [reasonCodesData, setReasonCodesData] = useState(false);
  const [uom, setUom] = useState(false);
  const [productType, setProductType] = useState(false);
  const [manufacturingFacilityType, setManufacturingFacilityType] = useState(false);
  const [poStatus, setPoStatus] = useState(false);
  const [batchStatus, setBatchStatus] = useState(false);
  const [shipmentStatus, setShipmentStatus] = useState(false);
  const [documentType, setDocumentType] = useState(false);
  const [documentCategory, setDocumentCategory] = useState(false);
  const [formatType, setFormatType] = useState(false);
  const [digitalizationCode, setDigitalizationCode] = useState(false);
  const [materialType, setmaterialType] = useState(false);
  const [processFlow, setProcessFlow] = useState(false);
  const [recheckTimeWindows, setRecheckTimeWindows] = useState([]);
  const [recheckTimeWindowRefresh, setRecheckTimeWindowRefresh] = useState(false);
  const [recheckLoading, setRecheckLoading] = useState(false);
  const [recheckError, setRecheckError] = useState(null);

     const [filters, setFilters] = useState({
         searchBy: "",
         searchTerm: "",
         reasonCodeType: "all",
         reasonCodeGroupType: "all",
         status: "all",
       });
const network = addSponsorList?.data?.network || rowNetwork;
  const networkUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL;
const fetchProductModalities = async () => {
    setLoading(true);
    setError(null);

   

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantDrugTypes/false`;

      const response = await axios.get(url);

      const drugTypeList = response.data?.data?.drugTypeList || [];

      const formatted = drugTypeList.map((item, index) => ({
        ...item,
        id: item.drugTypeID || `ID-${index + 1}`,
        name: item.drugTypeName || "",
        selected: !!item.activated,
        isNew: false,
      }));

      setModalities(formatted);
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
     
      setLoading(false);
    }
  };

  useEffect(() => {
    if (networkUrl && network) {
      fetchProductModalities();
    }
  }, [network, networkUrl, productModalities]);

 const fetchPlantSupplyTypes = async () => {
    setError(null);
    setLoading(true);
   

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantSupplyTypes/false`;
      const response = await axios.get(url);

      if (response.data?.data?.status) {
        const list = response.data.data.supplyTypeList || [];
        const formatted = list.map((item, index) => ({
          ...item,
          id: item.supplyTypeID || `ID-${index + 1}`,
          name: item.supplyTypeName || "",
          selected: !!item.activated,
          isNew: false,
        }));

        setSupplyTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
        console.error("Failed to fetch product types");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
      console.error("Error fetching product types:", error);
    } finally {
      setLoading(false);
   
    }
  };
  useEffect(() => {
    if (networkUrl && network) {
      fetchPlantSupplyTypes();
    }
  }, [networkUrl, network, manufacturingSupplyTypes]);

    const fetchPlantTypes = async () => {
        setError(null);
        setLoading(true);
       
    
        try {
          const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantTypes/false`;
          const response = await axios.get(url);
          const data = response?.data?.data;
    
    
          if (data?.status === true || data?.status === "true") {
            const list = data.plantTypeList || [];
    
            const formatted = list.map((item, index) => ({
              ...item,
              id: item.plantTypeID || `ID-${index + 1}`,
              name: item.plantTypeName || "",
              selected: !!item.activated,
              isNew: false,
            }));
    
            setPlantTypes(formatted);
          } else {
            setError("Something went wrong. Please try again.");
          }
        } catch (err) {
          console.error("API Error:", err);
          setError("Something went wrong. Please try again.");
        } finally {
          setLoading(false);
        
        }
      };
    
      useEffect(() => {
        if (networkUrl && network) {
          fetchPlantTypes();
        }
      }, [networkUrl, network, plantType]);

       const fetchUOMs = async () => {
          setError(null);
          setLoading(true);
        
      
          try {
            const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchAllUOMs/false`;
            const response = await axios.get(url);
            const data = response?.data?.data;
      
      
            const list = data.productUOMsList || [];
            if (data?.status === true || data?.status === "true") {
              const formatted = list.map((item, index) => ({
                id: item.uomID || `ID-${index + 1}`,
                name: item.uom || "",
                selected: !!item.activated,
                isNew: false,
                uomType: item.uomType,
              }));
              setUoms(formatted);
            } else {
              setError("Something went wrong. Please try again.");
            }
          } catch (err) {
            console.error("API Error:", err);
            setError("Something went wrong. Please try again.");
          } finally {
            setLoading(false);
      
          }
        };
        useEffect(() => {
          if (networkUrl && network) {
            fetchUOMs();
          }
        }, [networkUrl, network, uom]);

        const fetchReasonCodes = async (updatedFilters = filters) => {
            setLoading(true);
            setError(null); // Reset error state before new fetch

            // Open backdrop before API call

            try {
              const requestObject = {
                searchField: updatedFilters.searchBy || "all",
                  searchValue: updatedFilters.searchTerm || "",
                  reasonCodeGroupType: updatedFilters.reasonCodeGroupType || "all",
                  reasonCodeType: updatedFilters.reasonCodeType || "all",
                  status: updatedFilters.status || "all",
                  collaboratorTypeID: "all",
                }; 
          
                const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchReasonCodes`;
          
                const response = await axios.post(url, requestObject);
                if (response.data.status) {
                  const result = response.data.data.reasonCodeList || [];
                  setReasonCodes(result);
                  setFilteredData(result);
                  setLastSyncTime(new Date());
                }
          
                // Close backdrop after successful response
                
              } catch (error) {
                setError("Something went wrong. Please try again.");
          
                // Close backdrop on error
              
              } finally {
                setLoading(false);
                setUploadSuccess(false);
              }
            };
          
            // On component mount, fetch data
            useEffect(() => {
              if (networkUrl && network) {
                fetchReasonCodes();
              }
            }, [networkUrl, network, filters, reasonCodesData]);
  const fetchProductTypes = async () => {
      setError(null);
      setLoading(true);
    
      try {
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchProductTypes/false`;
        const response = await axios.get(url);
        const data = response?.data?.data;


        if (data?.status === true || data?.status === "true") {
          const list = data.productTypeList || [];

          const formatted = list.map((item, index) => ({
            id: item.productTypeID || `ID-${index + 1}`,
            name: item.productTypeName || "",
            type: item.productType,
            selected: !!item.activated,
            isNew: false,
          }));

          setProductTypes(formatted);
        } else {
          setError("Something went wrong. Please try again.");
        }
      } catch (err) {
        console.error("API Error:", err);
        setError("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
    
      }
    };
    useEffect(() => {
      if (networkUrl && network) {
    fetchProductTypes();
  }
  }, [networkUrl, network, productType]);

  const fetchFacilityTypes = async () => {
      try {
        setLoading(true); // Show loading indicator
        setError(null); // Clear any previous errors
  
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFacilityTypes/false`;
        const response = await axios.get(url);
  
        const data = response?.data?.data;
  
  
        if (data?.status === true || data?.status === "true") {
          const list = data.facilityTypesList || [];
  
          const formatted = list.map((item, index) => ({
            id: item.facilityTypeID || `ID-${index + 1}`,
            name: item.facilityTypeName || "",
            type: item.facilityType || "default",
            selected: !!item.activated,
            associatedProductTypes: item.associatedProductTypes.map(
              (product) => ({
                id: product.productTypeID,
                name: product.productTypeName,
              })
            ),
            lastUpdatedBy: item.lastUpdatedBy || "",
            isNew: false,
          }));
  
          setFacilityTypes(formatted); // Update the state with the fetched facility types
        } else {
          console.error("Failed to fetch facility types.");
          setError("Failed to fetch facility types. Please try again.");
        }
      } catch (error) {
        console.error("Error fetching facility types:", error);
        setError(
          "An error occurred while fetching facility types. Please try again."
        );
      } finally {
        setLoading(false); // Hide loading indicator
      }
    };
  
    useEffect(() => {
      if (networkUrl && network) {
        fetchFacilityTypes();
      }
    }, [networkUrl, network, manufacturingFacilityType]);

    const fetchPoStatuses = async () => {
    setLoading(true); // Show loading spinner
    setError(""); // Reset error state
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFGStatuses/false`; // API endpoint
      const response = await axios.get(url);

      if (response.data?.status === true || response.data?.status === "true") {
        // Map the API response to match the expected structure
        const mappedStatuses = response.data?.data?.poStatuses?.map(
          (status) => ({
            id: status.status_id,
            name: status.status_name,
            selected: status.activated,
            type: status.status_type,
            isNew: false,
            newStatusName: status.newStatusName,
          })
        );

        setPoStatuses(mappedStatuses || []); // Update state with mapped statuses
      } else {
        console.error("Failed to fetch PO statuses:", response.data?.message);
        setError(response.data?.message || "Failed to fetch PO statuses.");
      }
    } catch (error) {
      console.error("Error fetching PO statuses:", error);
      setError("An error occurred while fetching PO statuses.");
    } finally {
      setLoading(false); // Hide loading spinner
    }
  };

  useEffect(() => {
    if (networkUrl && network) {
      fetchPoStatuses();
    }
  }, [networkUrl, network, poStatus]);

   const fetchBatchStatuses = async () => {
    setError(null);
    setLoading(true);

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFGStatuses/false`;
      const response = await axios.get(url);
      const data = response?.data?.data;


      if (response.data?.status === true || response.data?.status === "true") {
        const list = data?.batchStatuses || [];

        // Map the API response to match the expected structure
        const formattedStatuses = list.map((item, index) => ({
          id: item.status_id || `ID-${index + 1}`,
          name: item.status_name || "",
          selected: !!item.activated,
          isNew: false,
          type: item.status_type,
          newName: item.newStatusName,
        }));

        setBatchStatuses(formattedStatuses);
      } else {
        console.error(
          "Failed to fetch batch statuses:",
          response.data?.message
        );
        setError(response.data?.message || "Failed to fetch batch statuses.");
      }
    } catch (error) {
      console.error("Error fetching batch statuses:", error);
      setError("An error occurred while fetching batch statuses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
     if (networkUrl && network) {
    fetchBatchStatuses();
    }
  }, [networkUrl, network, batchStatus]);

 

  const fetchShipmentStatuses = async () => {
      setError(null); // Reset error state
      setLoading(true); // Show loading spinner
  
      try {
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFGStatuses/false`; // API endpoint
        const response = await axios.get(url);
        const data = response?.data?.data;
  
  
        if (response.data?.status === true || response.data?.status === "true") {
          const list = data?.shipmentStatuses || [];
  
          // Map the API response to match the expected structure
          const formattedStatuses = list.map((item, index) => ({
            id: item.status_id || `ID-${index + 1}`, // Use ID from API or generate one
            name: item.status_name || "", // Use name from API or fallback
            selected: !!item.activated, // Convert activation state to boolean
            type: item.status_type,
            isNew: false, // Default to false for fetched statuses
          }));
  
          setShipmentStatuses(formattedStatuses); // Update state with formatted statuses
        } else {
          console.error(
            "Failed to fetch shipment statuses:",
            response.data?.message
          );
          setError(
            response.data?.message || "Failed to fetch shipment statuses."
          );
        }
      } catch (error) {
        console.error("Error fetching shipment statuses:", error);
        setError("An error occurred while fetching shipment statuses.");
      } finally {
        setLoading(false); // Hide loading spinner
      }
    };
    useEffect(() => {
      if (networkUrl && network) {
        fetchShipmentStatuses();
      }
    }, [networkUrl, network, shipmentStatus]);

    const fetchDocumentTypes = async () => {
        setLoading(true); // Show the loading spinner
        setError(""); // Reset error state before making the API call
        try {
          const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchDocumentTypes/false`; // API endpoint
          const response = await axios.get(url);
    
    
          if (response.data?.status === true || response.data?.status === "true") {
            // Check if documentTypeList exists and is an array
            const documentTypesList = response.data?.data?.documentTypesList || [];
    
    
            // Map the API response to match the expected structure
            const mappedDocumentTypes = documentTypesList.map((doc) => ({
              id: doc.documentTypeID, // Map documentTypeID to id with fallback
              name: doc.documentTypeName, // Map documentTypeName to name with fallback
              selected: !!doc.activated, // Map activated to selected, convert to boolean
              isNew: false,
              newDocumentTypeName: doc.newDocumentTypeName,
              type: doc.documentType,
    
              // Default to false for fetched document types
            }));
    
            setDocumentTypes(mappedDocumentTypes); // Update state with mapped document types
          } else {
            console.error(
              "Failed to fetch document types:",
              response.data?.message
            );
            setError(
              response.data?.message || "Something went wrong. Please try again."
            ); // Set error message
          }
        } catch (error) {
          console.error("Error fetching document types:", error);
          setError("Something went wrong. Please try again."); // Set error message
        } finally {
          setLoading(false); // Hide the loading spinner
        }
      };
    
      useEffect(() => {
        if (networkUrl && network) {
          fetchDocumentTypes(); // Fetch document types on component mount
        }
      }, [networkUrl, network, documentType]);

      const fetchDocumentCategories = async () => {
        setLoading(true); // Show the loading spinner
        setError(""); // Reset error state before making the API call
        try {
          const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchDocumentCategories/false`; // API endpoint
          const response = await axios.get(url);
    
          if (response.data?.status === true || response.data?.status === "true") {
            // Check if documentCategoryList exists and is an array
            const documentCategoryList = response.data?.documentCategoryList || [];
            
            // Map the API response to match the expected structure
            const mappedDocumentCategories = documentCategoryList.map((doc) => ({
              id: doc.documentCategoryID, // Map documentCategoryID to id
              name: doc.documentCategoryName, // Map documentCategoryName to name
              selected: !!doc.activated, // Map activated to selected, convert to boolean
              isNew: false,
              type: doc.documentCategoryType, // Map documentCategoryType to type
              lastUpdatedBy: doc.lastUpdatedBy, // Keep lastUpdatedBy info
            }));

            setDocumentCategories(mappedDocumentCategories); // Update state with mapped document categories
          } else {
            console.error("Failed to fetch document categories:", response.data?.message);
            setError(response.data?.message || "Something went wrong. Please try again.");
          }
        } catch (error) {
          console.error("Error fetching document categories:", error);
          setError("Something went wrong. Please try again."); // Set error message
        } finally {
          setLoading(false); // Hide the loading spinner
        }
      };

      useEffect(() => {
        if (networkUrl && network) {
          fetchDocumentCategories(); // Fetch document categories on component mount
        }
      }, [networkUrl, network, documentCategory]);

       const fetchFormatTypes = async () => {
          setError(null);
          setLoading(true);
        
      
          try {
            const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchFileFormatTypes/false`;
            const response = await axios.get(url);
            const data = response?.data?.data;
      
      
            if (data?.status === true || data?.status === "true") {
              const list = data.fileFormatTypesList || [];
      
              const formatted = list.map((item, index) => ({
                id: item.fileFormatTypeID || `ID-${index + 1}`,
                name: item.fileFormatTypeName || "",
                selected: !!item.activated,
                isNew: false,
                type: item.fileFormatType,
              }));
      
              setFormatTypes(formatted);
            } else {
              setError("Something went wrong. Please try again.");
            }
          } catch (err) {
            console.error("API Error:", err);
            setError("Something went wrong. Please try again.");
          } finally {
            setLoading(false);
           
          }
        };
      
        useEffect(() => {
          if (networkUrl && network) {
            fetchFormatTypes();
          }
        }, [networkUrl, network, formatType]);

  const fetchDigitalizationCodes = async () => {
    setError(null);
    setLoading(true);

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchDigitalizationCodes`;
      const response = await axios.get(url);
      const data = response?.data;

      if (data?.status === true || data?.status === "true") {
       const list = data.digitalizationCodesList || [];

       const digitalizationCodesList = list.map((item, index) => ({
          id: item.digitalizationCodeID || `ID-${index + 1}`,
          code: item.digitalizationCode,
          description: item.digitalizationCodeDescription || "",
          selected: !!item.activated,
          isNew: false,
          type: item.digitalizationCodeType,
      }));

        setDigitalizationCodes(digitalizationCodesList);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(networkUrl && network){
       fetchDigitalizationCodes();
    }
  }, [networkUrl, network, digitalizationCode]);

  const handleTabClick = (index) => {
    setValue(index);
    if (handleOpenTab) {
      handleOpenTab(index);
    }
  };
  const handleNext = () => {
    if (value < tabConfigs.length - 1) {
      setValue(value + 1);
    }
  };

  const handleBack = () => {
    if (value > 0) {
      setValue(value - 1);
    }
  };

  const [materialTypes, setMaterialTypes] = useState([]);
  const [processFlows, setProcessFlows] = useState([]);

  // Fetch Material Types
  const fetchMaterialTypes = async () => {
    setError(null);
    setLoading(true);
    const cmoConfig = false
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchMaterialTypes/${cmoConfig}`;
      const response = await axios.get(url);
      const data = response?.data;
      if (data?.status === true || data?.status === "true") {
        const list = data.materialTypeList || [];
        const formatted = list.map((item, index) => ({
          id: item.materialTypeID || `ID-${index + 1}`,
          name: item.materialTypeName || "",
          type: item.materialType,
          selected: !!item.activated,
          isNew: false,
        }));
        setMaterialTypes(formatted);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
          if (networkUrl && network) {
            fetchMaterialTypes();
          }
        }, [networkUrl, network, materialType]);

  // Fetch Process Flows
  const fetchProcessFlows = async () => {
    setError(null);
    setLoading(true);
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchAllProcessFlows/false`;
      const response = await axios.get(url);
      if (response.data && response.data.status && response.data.processFlowsList) {
        const transformedData = response.data.processFlowsList.map((item, index) => ({
          id: item.processFlowID?.toString() || `ID-${index + 1}`,
          name: item.processFlowName || '',
          mapping: "Click here to view",
          version: item.versionHistory && item.versionHistory.length > 0 ? "Click here to view" : "NA",
          qaCheck: item.qaCheckRequired ? "Yes" : "No",
          cmoCountry: item.cmoCountry || '',
          addresseeOrgName: item.addresseeOrgName || '',
          addresseeCountry: item.addresseeCountry || '',
          vendor: item.cmoCountry && item.addresseeOrgName && item.addresseeCountry
            ? [`${item.cmoCountry} - ${item.addresseeOrgName} - ${item.addresseeCountry}`]
            : [],
          selected: !!item.activated,
          isNew: false,
          processFlowType: item.processFlowType || 'Default',
          originalData: item,
        }));
        setProcessFlows(transformedData);
      }
    } catch (e) {
      setError("Error fetching process flows.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (networkUrl && network) fetchProcessFlows();
  }, [networkUrl, network, processFlow]);

  const fetchRecheckTimeWindowConfig = async () => {
    if (!networkUrl || !network) return;
    setRecheckLoading(true);
    setRecheckError(null);
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchRecheckTimeWindowConfig`;
      const response = await axios.get(url);
      if (response.data?.status === true || response.data?.status === "true") {
        const list = response.data?.data?.recheckConfigList || [];
        setRecheckTimeWindows(list);
      } else {
        setRecheckError("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("API Error:", err);
      setRecheckError("Something went wrong. Please try again.");
    } finally {
      setRecheckLoading(false);
    }
  };

  useEffect(() => {
    if (networkUrl && network) fetchRecheckTimeWindowConfig();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [networkUrl, network]);

  useEffect(() => {
    if (recheckTimeWindowRefresh) {
      fetchRecheckTimeWindowConfig();
      setRecheckTimeWindowRefresh(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recheckTimeWindowRefresh]);


  const tabConfigs = [
    {
      //label={`Network Type (${networkTypes.length})`}
      // label: "Product Modality (${drugTypeList.length} )",
      label: `Product Modality (${modalities.length})`,
      component: <ProductModalityTab handleNext={handleNext} sponsorHandleBack={sponsorHandleBack}  addSponsorList={addSponsorList}
                rowData={rowData}                
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setProductModalities={setProductModalities}
                />,
    },
    {
      label: `Manufacturing Supply Type (${supplyTypes.length})`,
      component: (
        <ManufacturingSupplyTab
          handleNext={handleNext}
          handleBack={handleBack}
           addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setManufacturingSupplyTypes={setManufacturingSupplyTypes}
        />
      ),
    },
    {
      label: `Plant Type (${plantTypes.length})`,
      component: (
        <PlantTypeTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setPlantType={setPlantType}
                />
      ),
    },
    {
      label: `UOM (${uoms.length})`,
      component: <UOMTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData} 
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setUom={setUom}
                />,
    },
    {
      label: `Reason Code Group (${reasonCodes.length})`,
      component: (
        <ReasonCodeGroupTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setReasonCodesData={setReasonCodesData}
                />
      ),
    },
    {
      label: `Material Type (${materialTypes.length})`,
      component: (
        <MaterialTypeTab
          handleNext={handleNext}
          handleBack={handleBack}
          addSponsorList={addSponsorList}
          rowData={rowData}
          updateNetworkData={updateNetworkData}
          rowNetwork={rowNetwork}
          setMaterialType={setmaterialType}
        />
      ),
    },
    {
      label: `Product Type (${productTypes.length})`,
      component: (
        <ProductTypeTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setProductType={setProductType}
                />
      ),
    },
    {
      label: `Manufacturing Facility Type (${facilityTypes.length})`,
      component: (
        <ManufacturingFacilityTypeTab
          handleNext={handleNext}
          handleBack={handleBack}
           addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setManufacturingFacilityType={setManufacturingFacilityType}
        />
      ),
    },
    {
      label: `PO Status (${poStatuses.length})`,
      component: (
        <POStatusTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setPoStatus={setPoStatus}
                />
      ),
    },
    {
      label: `Batch Status (${batchStatuses.length})`,
      component: (
        <BatchStatusTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setBatchStatus={setBatchStatus}
                />
      ),
    },
    {
      label: `Shipment Status (${shipmentStatuses.length})`,
      component: (
        <ShipmentStatusTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setShipmentStatus={setShipmentStatus}
                />
      ),
    },
    {
      label: `Document Categories (${documentCategories.length})`,
      component: (
        <DocumentCategoriesTab 
          handleNext={handleNext} 
          handleBack={handleBack}  
          addSponsorList={addSponsorList}
          rowData={rowData}
          updateNetworkData={updateNetworkData}
          rowNetwork={rowNetwork}
          setDocumentCategory={setDocumentCategory}
        />
      ),
    },
    {
      label: `Document Type (${documentTypes.length})`,
      component: (
        <DocumentTypeTab 
          handleNext={handleNext} 
          handleBack={handleBack}  
          addSponsorList={addSponsorList}
          rowData={rowData}
          updateNetworkData={updateNetworkData}
          rowNetwork={rowNetwork}
          documentCategories={documentCategories}
          setDocumentType={setDocumentType}
        />
      ),
    },
    {
      label: `Format Type (${formatTypes.length})`,
      component: (
        // <FormatTypeTab handleNext={handleNext} sponsorHandleNext={sponsorHandleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
        <FormatTypeTab handleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setFormatType={setFormatType}
                />
      ),
    },
    {
      label: `Process Flow (${processFlows.length})`,
      component: (
        <ProcessFlowTab
          handleNext={handleNext}
          handleBack={handleBack}
          addSponsorList={addSponsorList}
          rowData={rowData}
          updateNetworkData={updateNetworkData}
          rowNetwork={rowNetwork}
          setProcessFlow={setProcessFlow}
        />
      ),
    },
    {
      label: `Digitalization Codes (${digitalizationCodes.length})`,
      component: (
        <DigitalizationCodesTab sponsorHandleNext={handleNext} handleBack={handleBack}  addSponsorList={addSponsorList}
                rowData={rowData}
                updateNetworkData={updateNetworkData}
                rowNetwork={rowNetwork}
                setDigitalizationCode={setDigitalizationCode}
                />
      ),
    },
    {
      label: `Recheck Time Window (${recheckTimeWindows.length})`,
      component: (
        <RecheckTimeWindowTab
          recheckTimeWindowConfig={recheckTimeWindows}
          setRecheckTimeWindowRefresh={setRecheckTimeWindowRefresh}
          loading={recheckLoading}
          error={recheckError}
          handleBack={handleBack}
          sponsorHandleNext={sponsorHandleNext}
          networkUrl={networkUrl}
          network={network}
          addSponsorList={addSponsorList}
          rowData={rowData}
        />
      ),
    },
    // {
    //   label: "Fetch/Upload Setting ",
    //   component: (
    //     <UploadFetchSettingTab
    //       sponsorHandleNext={sponsorHandleNext}
    //       handleBack={handleBack}
    //        addSponsorList={addSponsorList}
    //             rowData={rowData}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    const recheckTabIndex = tabConfigs.findIndex((t) =>
      t.label.startsWith("Recheck Time Window")
    );
    if (recheckTabIndex !== -1 && value === recheckTabIndex && networkUrl && network) {
      fetchRecheckTimeWindowConfig();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.headerContainer}>
        <Typography className={classes.headerText}>
          Sponsor Network Configurations
        </Typography>
        <hr className={classes.headerLine} />
      </div>

      {/* Tabs Container */}
      <div className={classes.tabsContainer}>
        {tabConfigs.map((tab, index) => (
          <CustomTab
            key={index}
            label={tab.label}
            isActive={value === index}
            onClick={() => setValue(index)}
          />
        ))}
      </div>

      {/* Tab Content */}
      <div className={classes.tabContent}>
        {tabConfigs.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </div>
    </div>
  );
};

export default SponsorNetworkConfigurations;
